// Builds the value of the data-mdlfy-cms attribute (`<table>:<row id>:<column>`),
// which lets a database text value be edited directly in the preview.
// Returns undefined when the row has no real id (fallback content), so nothing is tagged.
export const cms = (table: string, id: string | null | undefined, column: string): string | undefined =>
    id ? `${table}:${id}:${column}` : undefined
